import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Error as SchemaError } from '../schemas/Error';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Удаляет промокод из указанной группы
 * @tags PromocodeGroups
 * @summary Удаление промокода из группы
 */
export const PromocodeGroupPromocodeDeleteContentType = '' as const;
export type PromocodeGroupPromocodeDeleteRequest = void;
export type PromocodeGroupPromocodeDeleteResponses = LinkCommonErrorResponses & {
    /**
     * @description Not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type PromocodeGroupPromocodeDeleteResponseSuccess = undefined;
export type PromocodeGroupPromocodeDeleteSearchParams = undefined;
export type PromocodeGroupPromocodeDeletePathParameters = {
    group_id: string;
    promocode_id: string;
};
export const PromocodeGroupPromocodeDeleteUrl = '/promocode_groups/{group_id}/promocodes/{promocode_id}' as const;
export const PromocodeGroupPromocodeDeleteMethod = 'DELETE' as const;
export const getPromocodeGroupPromocodeDeleteUrl = (params: PromocodeGroupPromocodeDeletePathParameters) =>
    PromocodeGroupPromocodeDeleteUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof PromocodeGroupPromocodeDeletePathParameters) => String(params[param])
    );
